export const globalScripts = () => {};
export const globalStyles = ":host{box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}";
